export default __webpack_public_path__ + "static/media/gallery_10.b13c73bf.jpg";